import { render, staticRenderFns } from "./PendingPaymentTransactionDetails.vue?vue&type=template&id=069e74cc&"
import script from "./PendingPaymentTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./PendingPaymentTransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports